import styled, { css } from 'styled-components';

const Header = styled.h1`
  color: ${(p) => p.theme.text};
  font-size: 2.8rem;
  font-weight: 900;

  @media screen and (max-width: 767px) {
    font-size: 1.6rem;
  }

  @media screen and (max-height: 600px) {
    font-size: 1.4rem;
  }

  @media screen and (max-height: 600px) and (min-width: 900px) {
    font-size: 2.5rem;
  }

  ${(p) =>
    p.primary &&
    css`
      color: ${(p) => p.theme.accent.primary};
    `}

  ${(p) =>
    p.large &&
    css`
      font-size: 3.5rem;

      @media screen and (max-width: 767px) {
        font-size: 2rem;
      }

      @media screen and (max-height: 600px) {
        font-size: 1.4rem;
      }

      @media screen and (max-height: 600px) and (min-width: 900px) {
        font-size: 2.5rem;
      }
    `}
`;

export default Header;
